// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '../common/Button';
import Tooltip from '../common/Tooltip';
import { Icons } from '@its-svp/svp-common-ui';
// css
import '../../styles/components/correlations/SecurityCorrelationsQuestionForm.scss';


class SecurityCorrelationsQuestionForm extends Component {

  renderTitle() {
    const { correlation, answer } = this.props;

    return (
      <label className='h6 security-correlations-question-form__title'>
        {correlation.title}
        <span className='hidden'>{answer}</span>
      </label>
    );
  }

  renderSIEMEssentialIndicator() {
    const { correlation } = this.props;

    if (correlation.critical) {
      return (
        <div className='security-correlations-question-form__siem-essential-indicator'>
          SIEM Essential
        </div>
      );
    }
  }

  renderOptions() {
    const { correlation } = this.props;

    return (
      <div className='security-correlations-question-form__options'>
        <Tooltip
          className='security-correlations-question-form__tooltip'
          text={correlation.description}
        >
          <Icons.QuestionMark />
        </Tooltip>
        <Button
          primary={correlation.answer === 0}
          label='No'
          onClick={() => this.props.onAnswer(0)}
        />
        <Button
          primary={correlation.answer === 1}
          label='Yes'
          onClick={() => this.props.onAnswer(1)}
        />
      </div>
    );
  }

  render() {
    return (
      <div className='security-correlations-question-form'>
        <div className='row'>
          <div className='col-xs-12 col-sm-5'>
            {this.renderTitle()}
            {this.renderSIEMEssentialIndicator()}
          </div>
          <div className='col-xs-12 col-sm-7'>
            {this.renderOptions()}
          </div>
        </div>
      </div>
    );
  }
}

SecurityCorrelationsQuestionForm.propTypes = {
  correlation: PropTypes.object.isRequired,
  onAnswer: PropTypes.func.isRequired,
  answer: PropTypes.string
};

export default SecurityCorrelationsQuestionForm;



// WEBPACK FOOTER //
// ./src/components/correlations/SecurityCorrelationsQuestion.js